import { render } from "./DebugCommands.vue?vue&type=template&id=72909a0c&scoped=true"
import script from "./DebugCommands.vue?vue&type=script&lang=js"
export * from "./DebugCommands.vue?vue&type=script&lang=js"

import "./DebugCommands.vue?vue&type=style&index=0&id=72909a0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72909a0c"]])

export default __exports__